var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 29.3337H9.33333C8.62609 29.3337 7.94781 29.0527 7.44772 28.5526C6.94762 28.0525 6.66667 27.3742 6.66667 26.667V9.33366H4V6.66699H9.33333V5.33366C9.33333 4.62641 9.61428 3.94814 10.1144 3.44804C10.6145 2.94794 11.2928 2.66699 12 2.66699H20C20.7072 2.66699 21.3855 2.94794 21.8856 3.44804C22.3857 3.94814 22.6667 4.62641 22.6667 5.33366V6.66699H28V9.33366H25.3333V26.667C25.3333 27.3742 25.0524 28.0525 24.5523 28.5526C24.0522 29.0527 23.3739 29.3337 22.6667 29.3337ZM9.33333 9.33366V26.667H22.6667V9.33366H9.33333ZM12 5.33366V6.66699H20V5.33366H12ZM20 24.0003H17.3333V12.0003H20V24.0003ZM14.6667 24.0003H12V12.0003H14.6667V24.0003Z",
    fill: "#EB4960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.35ca2419.svg";
export { ForwardRef as ReactComponent };